import React, { useContext } from 'react';

import { Icon } from '@americanexpress/aqx-components';

import { QuickViewContext } from './Tile';

import styles from '../__styles__/quickView.scss?modules';

const CloseDrawer = () => {
  const { setIsQuickViewOpen } = useContext(QuickViewContext);
  return (
    <button
      className={styles.closeDrawerButton}
      aria-label="close drawer"
      onClick={() => setIsQuickViewOpen(false)}
    >
      <Icon directory="dls" imageName="dls-icon-cancel-circle" />
    </button>
  );
};

export default CloseDrawer;
